import "./TeamsLoader.scss";

import { Loader, LoaderProps } from "@fluentui/react-northstar";
import React from "react";

type TeamsLoaderParams = {
  isLoading: boolean;
  loadingMessage?: string;
} & LoaderProps;

export const TeamsLoader: React.FC<TeamsLoaderParams> = ({
  isLoading,
  loadingMessage,
  children,
  ...loaderProps
}) => {
  if (isLoading) {
    return (
      <div className="is-flex justify-center teamsloader">
        <Loader label={loadingMessage} {...loaderProps} />
      </div>
    );
  }

  return <>{children}</>;
};
